import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import './styles.scss'
import user from '../../shared/user'
import { trackGtmEvent } from '../../util/tracking'
import ReactTooltip from 'react-tooltip'

//import l10n from '../../shared/l10n'
//const { foo: { foo } } = l10n

const UnlockEstateAddress = ({
  objektnr,
  error,
  success,
  isSubmitting,
  submit,
}) => {
  useEffect(() => {
    ReactTooltip.rebuild()
  })

  const handleSubmit = values => {
    //console.log(values)
    if (!values.vorzeitiger_beginn) {
      trackGtmEvent('expose-anfordern', {
        'objekt-name': objektnr,
      })
    } else {
      trackGtmEvent('expose-anfordern-vorzeitiger-beginn', {
        'objekt-name': objektnr,
      })
    }

    //console.log(values)
    submit(values)
  }

  // const validation = () => !courtagepflichtig

  return (
    <div className={`dhsv_unlock_estate_address`}>
      {success && (
        <div className={`dhsv_success_message`}>
          <p>{success}</p>
        </div>
      )}
      {error && (
        <div className={`dhsv_error_message`}>
          <p>{error}</p>
        </div>
      )}
      {!success && !error && (
        <Form
          onSubmit={handleSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              {!user.newsletter && (
                <>
                  <p>
                    Durch Klick auf „Bestätigen“ stimme ich zu, regelmäßig über
                    relevante Inhalte, Produkte und Services per E-Mail, Telefon
                    und Post informiert zu werden. Auch habe ich die{' '}
                    <a href="/datenschutz" target="_blank">
                      Datenschutzerklärung
                    </a>{' '}
                    zur Kenntnis genommen. Widerruf jederzeit{' '}
                    <a href="/datenschutz" target="_blank">
                      hier
                    </a>{' '}
                    möglich.
                  </p>
                  <p>
                    Zur{' '}
                    <a href="/datenschutz" target="_blank">
                      Datenschutzerklärung.
                    </a>
                  </p>
                </>
              )}
              <div className="buttons">
                <button
                  className={`btn btn--primary`}
                  type="submit"
                  disabled={isSubmitting}
                >
                  Bestätigen
                </button>
              </div>
            </form>
          )}
        />
      )}
    </div>
  )
}

UnlockEstateAddress.propTypes = {
  courtagepflichtig: PropTypes.bool,
  objektnr: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  success: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isSubmitting: PropTypes.bool,
  submit: PropTypes.func,
}

export default UnlockEstateAddress
